import { getRangeValue } from '../../../util/getRangeValue';
import { EstimationInput } from '../../App';
import { EmissionCalculationInTonnes } from '../../configs/industryCalculationTemplate';
import { EmissionCategories, throwIfAnyUndefined } from '../calculations';

export const calculateEmissionOffice = (
  emissionsCategories: EmissionCategories,
  input: EstimationInput,
): EmissionCalculationInTonnes => {
  const { employees } = input;

  const {
    office_vehicles_tonnes,
    office_electricity_tonnes,
    office_airTravel_tonnes,
    office_accomodation_tonnes,
    office_taxisRentalCars_tonnes,
    office_commuting_tonnes,
    office_water_tonnes,
    office_waste_tonnes,
    office_vehicleRanges_tonnes,
    office_accomodationRanges_tonnes,
  } = emissionsCategories;

  throwIfAnyUndefined(
    [
      office_vehicles_tonnes,
      office_electricity_tonnes,
      office_airTravel_tonnes,
      office_accomodation_tonnes,
      office_taxisRentalCars_tonnes,
      office_commuting_tonnes,
      office_water_tonnes,
      office_waste_tonnes,
      office_vehicleRanges_tonnes,
      office_accomodationRanges_tonnes,
    ],
    'office',
  );

  const vehicleMatrix = getRangeValue(
    employees,
    office_vehicleRanges_tonnes.ranges,
    office_vehicleRanges_tonnes.outOfRange,
  );
  const accomodationMatrix = getRangeValue(
    employees,
    office_accomodationRanges_tonnes.ranges,
    office_accomodationRanges_tonnes.outOfRange,
  );

  const accom =
    office_accomodation_tonnes *
    accomodationMatrix *
    (employees > 4 ? employees : 1);

  const tonnes =
    office_vehicles_tonnes * vehicleMatrix +
    office_electricity_tonnes * employees +
    office_airTravel_tonnes * employees +
    accom +
    office_taxisRentalCars_tonnes * employees +
    office_commuting_tonnes * employees +
    office_water_tonnes * employees +
    office_waste_tonnes * employees;
  return tonnes;
};
